import Marquee from "react-fast-marquee";

const WORDS = ["Weddings", "Family", "Editorial", "Brands", "Pets", "Sports", "Events", "Real Estate"];

export const EditorialMarquee = () => {
  return (
    <section data-testid="marquee-section" className="py-10 md:py-16 border-y border-[#2D2A26]/15 bg-[#F1EBE1] overflow-hidden">
      <Marquee speed={38} gradient={false} className="overflow-hidden">
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-display italic text-6xl md:text-8xl font-light px-8 text-[#2D2A26]">{w}</span>
            <span className="text-[#E2725B] text-3xl md:text-5xl px-2">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
